import { render, staticRenderFns } from "./AsCoach.vue?vue&type=template&id=9fd7c7f2&scoped=true"
import script from "./AsCoach.vue?vue&type=script&lang=js"
export * from "./AsCoach.vue?vue&type=script&lang=js"
import style0 from "./AsCoach.vue?vue&type=style&index=0&id=9fd7c7f2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd7c7f2",
  null
  
)

export default component.exports